import { resolvePublicAssetUrl } from '../utils/resolvePublicAssetUrl';

/** Faction and rarity paints used as SVG pattern fills on the War Effort world map. */
export const WAR_EFFORT_MAP_PAINT_PATHS = [
  '/images/red_paint.jpg',
  '/images/black_paint.jpg',
  '/images/green_paint.jpg',
  '/images/yellow_paint.jpg',
  '/images/purple_paint.jpg',
  '/images/blue_paint.jpg',
  '/images/gray_paint.jpg',
  '/images/darkblue_plaint.jpg',
  '/images/pink_paint.jpg',
  '/images/golden_paint.jpg'
];

const retainedPaintImages = [];
let paintPreloadStarted = false;

/**
 * Decode paint JPEGs into retained Image() objects so SVG <pattern> fills can
 * reuse the bitmap instead of re-fetching/re-decoding after the map remounts.
 */
export function preloadWarEffortMapPaintImages() {
  if (paintPreloadStarted) return;
  paintPreloadStarted = true;
  if (typeof Image === 'undefined') {
    throw new Error('preloadWarEffortMapPaintImages: Image is required');
  }
  WAR_EFFORT_MAP_PAINT_PATHS.forEach((assetPath) => {
    const img = new Image();
    img.src = resolvePublicAssetUrl(assetPath);
    retainedPaintImages.push(img);
  });
}
